var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "docker",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#303c42",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.04,
    cy: 16,
    r: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 9.5h3v3h-3zM4.5 9.5h3v3h-3zM7.5 9.5h3v3h-3zM10.5 9.5h3v3h-3zM4.5 6.5h3v3h-3zM7.5 6.5h3v3h-3zM10.5 6.5h3v3h-3zM10.5 3.5h3v3h-3zM13.5 9.5h3v3h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 11.5s-1.75-1.12-3-.5A3.45 3.45 0 0 0 19 8.5a3.64 3.64 0 0 0-.58 2.88 1 1 0 0 1-1 1.12H.5c0 6.25 3.83 8 7.5 8a13.76 13.76 0 0 0 12.06-7 4.68 4.68 0 0 0 3.44-2Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocker);
export default __webpack_public_path__ + "static/media/docker.e091ee091ad647b1dc61e6e46e1cddb9.svg";
export { ForwardRef as ReactComponent };